import React, { useContext, useEffect, useState } from "react";
import { uploadImage, UploadFn } from "../../compliance/utils";
import { CustomUpload } from "./index";
import { VerificationTag } from "../../settings/Verification/style";
import { NetworkErrorAlertContext } from "../../../context/NetworkErrorAlert";

type ProgressStatus = "idle" | "progress" | "done";

const statusToText = {
  PENDING: "Pending approval",
  FAILED: "Approval failed",
  "NOT UPLOADED": "Not yet uploaded",
  APPROVED: "Approved",
};

const SelfCustomUpload = ({
  onUpload,
  docId,
  docName,
  approvalStatus,
  upload,
  onUploadFinish,
}: {
  onUpload: (newDoc: any) => void;
  onUploadFinish?: () => void;
  docName?: string;
  docId: string;
  approvalStatus?: string;
  upload: UploadFn;
}) => {
  const { onShowAlert } = useContext(NetworkErrorAlertContext);
  const [uploadingProgress, setUploadingProgress] = useState(0);
  const [documentExistStatus, setDocumentExistStatus] = useState("idle");
  const [fileType, setFileType] = useState("");
  const [fileName, setFileName] = useState("");
  const [uploadingStatus, setUploadingStatus] =
    useState<ProgressStatus>("idle");

  const onUploadDocument = (file, docName) => {
    uploadImage({
      file,
      docName,
      upload,
      setUploadingProgress: setUploadingProgress,
      setFileType: setFileType,
      setDocumentExistStatus: setDocumentExistStatus,
      setUploadingStatus: setUploadingStatus,
      setFileName: setFileName,
      onFinish: onUploadFinish,
      onShowAlert,
    });
  };

  useEffect(() => {
    if (["APPROVED", "FAILED", "PENDING"].includes(approvalStatus)) {
      setUploadingStatus("done");
    }
  }, [approvalStatus]);

  useEffect(() => {
    if (uploadingStatus === "done") {
      const newDocDetail = {
        id: docId,
        fileName: fileName,
        fileType: fileType,
        uploadStatus: uploadingStatus,
        uploadProgress: uploadingProgress,
        docExistsStatus: documentExistStatus,
      };
      onUpload(newDocDetail);
    }
  }, [uploadingStatus]);

  return (
      <CustomUpload
        name="id"
        customRequest={({ file }) => onUploadDocument(file, docName)}
        progressPercent={uploadingProgress}
        uploadingStatus={uploadingStatus}
        approvalStatus={approvalStatus}
        doneText={
          <VerificationTag $status={approvalStatus}>
            {statusToText[approvalStatus] || approvalStatus}
          </VerificationTag>
        }
      />
  );
};

export default SelfCustomUpload;
